import { informationCircleOutline, checkmarkCircleOutline, alertCircleOutline } from "ionicons/icons";
import { toastController } from "@ionic/vue";
import i18n from '../i18n';

export interface IErrorHandlers {
    openToast(message: string, color?: string, duration?: number): void
    errorFilter(error: string[]): string
}

/**
 * Reusable functions for handling fetch errors integrated with state
 * @returns IErrorHandlers
 */
export function handleErrors(): IErrorHandlers {
    // Icons map:
    const iconsMap: any = {
        success: checkmarkCircleOutline,
        danger: alertCircleOutline,
        warning: informationCircleOutline,
    };

    // Error parser:
    const errorFilter = (error: string[]) => error[0];

    // Show message:
    const openToast = async (message: string, color = 'warning', duration = 2000) => {
        const { t, te } = i18n.global;
        if (te(message)) {
            message = t(message);
        }

        const optionalProperties = {};
        if (iconsMap[color]) {
            Object.assign(optionalProperties, { icon: iconsMap[color] });
        }

        const toast = await toastController.create({
            color,
            message,
            position: "top",
            duration: duration,
            ...optionalProperties
        });
        return toast.present();
    };

    return { errorFilter, openToast };
}